import React, { useEffect } from 'react'

const CollectionNameDropdown = props => {
  const { page, name, setName } = props

  useEffect(() => {
    setName('')
  }, [page])

  return (
    <div style={{ height: '30px', display: 'flex', alignItems: 'center' }}>
      <select
        value={name}
        onChange={e => {
          setName(e.target.value)
        }}
        style={{ paddingRight: '10px' }}
      >
        {page === 'home' ? (
          <>
            <option value="">배너를 선택하세요.</option>
            <option value="main">main</option>
            <option value="card">card</option>
            <option value="trio card">trio</option>
            <option value="artist">artist</option>
            <option value="md card">md</option>
            <option value="spotlight">spotlight</option>
            <option value="mini cards">mini</option>
            <option value="top table">top</option>
            <option value="free">free</option>
            <option value="center card">center</option>
          </>
        ) : page === 'new' ? (
          <>
            <option value="">배너를 선택하세요.</option>
            <option value="new main">new main</option>
          </>
        ) : page === 'search' ? (
          <>
            <option value="">배너를 선택하세요.</option>
            <option value="categories">categories</option>
          </>
        ) : page === 'ai' || page === 'nsfw' ? (
          <>
            <option value="">배너를 선택하세요.</option>
            <option value="ai card">card</option>
            {/* 그룹채팅 큐레이션. 디자인이 늘면 'group <layout>' 으로 옵션을 추가한다. */}
            <option value="group collage">group collage (그룹채팅)</option>
            {/* 씬플레이 큐레이션. 캐릭터마다 카드에 깔 배경과 표정을 고른다. */}
            <option value="sceneplay">sceneplay (씬플레이)</option>
          </>
        ) : (
          page === 'banner' && (
            <>
              <option value="">배너를 선택하세요.</option>
              <option value="companion">companion</option>
              <option value="nsfw">nsfw</option>
            </>
          )
        )}
      </select>
    </div>
  )
}

export default CollectionNameDropdown
